import { PERMISSIONS } from '@moleculeone/auth';
import { useSelector } from 'react-redux';

import { hasAnyPermission } from '@f/services/authentication/authentication.selectors';

export function useHasAnalogsAccess() {
  const hasAnalogsAccess = useSelector(state => {
    return hasAnyPermission(state, [PERMISSIONS.RETRO.APP.ANALOGS]);
  });

  return hasAnalogsAccess;
}
